import React from 'react'
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/AppEnvCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";

function AppEnv() {
  return (
    <Box sx={{ display: "flex" }}>
    <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
    <PageHeader pageTitle="Manage App Env" />
      <CrudManager
        data={schema}
        actionBtnName="Add Env "
        createFormTitle="Add Env"
        updateFormTitle="Update Env"
      />
    </Box>
  </Box>
  )
}

export default AppEnv
